module.exports = __webpack_public_path__ + "static/creamsoda-36163fc697bc0e09974087c4ec11b6ca.jpg";